<div *ngIf="iShowConsumptions">
  <table class="table consumption-table">
    <thead>
    <tr>
      <th scope="col" class="consumption-col-id" *ngIf="!iNavMobile">#</th>
      <th scope="col" class="consumption-col-date">Date</th>
      <th scope="col">Article</th>
      <th scope="col" class="consumption-col-price">Prix</th>
      <th scope="col" class="consumption-col-qty">Quantité</th>
      <th scope="col" class="consumption-col-total">Montant</th>
      <th scope="col" *ngIf="!iNavMobile && !iIsOneStudent">Elève</th>
      <th scope="col" class="consumption-col-description" *ngIf="!iNavMobile && !iIsStudent">Description</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let c of iConsumptions">
      <th class="consumption-col-id" scope="row" *ngIf="!iNavMobile">{{ c.id }}</th>
      <td class="consumption-col-date">{{ c.date | date:'dd/MM/YYYY' }}</td>
      <td>{{ c.article.name }}</td>
      <td class="consumption-col-price">{{ c.article.price }} €</td>
      <td class="consumption-col-qty">{{ c.quantity }}</td>
      <td class="consumption-col-total">{{ c.cost }} €</td>
      <td *ngIf="!iNavMobile && !iIsOneStudent">{{ c.studentName }}</td>
      <td class="consumption-col-description" *ngIf="!iNavMobile && !iIsStudent">{{ c.description }}</td>
    </tr>
    </tbody>
  </table>

  <app-pagination *ngIf="iPageConsumption" [iEmpty]="iPageConsumption.empty" [iFirst]="iPageConsumption.first"
                  [iLast]="iPageConsumption.last" [iNumber]="iPageConsumption.number" [iTotalPages]="iPageConsumption.totalPages"
                  [iPageSize]="iPageConsumption.size"
                  (currentPageChanged)="onChangeConsumptionPage($event)">
  </app-pagination>
</div>
